// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"31d6cfe0","793":"f6e13174"}[chunkId] + ".chunk.css";
};